// Mobile Menu Toggle
document.addEventListener('DOMContentLoaded', function() {
    const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
    const navLinks = document.querySelector('.nav-links');

    if (mobileMenuToggle) {
        mobileMenuToggle.addEventListener('click', function() {
            this.classList.toggle('active');
            navLinks.classList.toggle('active');
        });

        // Close menu when clicking a link
        const links = navLinks.querySelectorAll('a');
        links.forEach(link => {
            link.addEventListener('click', function() {
                mobileMenuToggle.classList.remove('active');
                navLinks.classList.remove('active');
            });
        });

        // Close menu when clicking outside
        document.addEventListener('click', function(event) {
            if (!event.target.closest('.nav-container')) {
                mobileMenuToggle.classList.remove('active');
                navLinks.classList.remove('active');
            }
        });
    }
});

// Smooth scrolling for navigation links
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
            target.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    });
});

// Navigation scroll effect
window.addEventListener('scroll', function() {
    const nav = document.querySelector('.nav');
    if (window.scrollY > 100) {
        nav.style.background = 'rgba(232, 226, 218, 0.98)';
        nav.style.boxShadow = '0 2px 20px rgba(69, 87, 99, 0.15)';
    } else {
        nav.style.background = 'rgba(232, 226, 218, 0.95)';
        nav.style.boxShadow = 'none';
    }
});

// Intersection Observer for animations
const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
};

const observer = new IntersectionObserver(function(entries) {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
        }
    });
}, observerOptions);

// Observe elements for scroll animations
document.addEventListener('DOMContentLoaded', function() {
    const animateElements = document.querySelectorAll(
        '.product-card, .benefit, .lifestyle-card, .pillar, .absorption-comparison'
    );
    
    animateElements.forEach(el => {
        el.style.opacity = '0';
        el.style.transform = 'translateY(30px)';
        el.style.transition = 'all 0.6s ease';
        observer.observe(el);
    });

    // Initialize scrolling bar
    initScrollingBar();
});

// Scrolling bar functionality - WIP Energy style
function initScrollingBar() {
    const scrollingTrack = document.getElementById('scrollingTrack');
    const aboutScrollingTrack = document.getElementById('aboutScrollingTrack');
    
    console.log('Initializing scrolling bars...');
    console.log('Main track found:', !!scrollingTrack);
    console.log('About track found:', !!aboutScrollingTrack);
    
    // Initialize main page scrolling bar
    if (scrollingTrack) {
        console.log('Creating items for main track');
        createScrollingItems(scrollingTrack);
    }
    
    // Initialize about page scrolling bar
    if (aboutScrollingTrack) {
        console.log('Creating items for about track');
        createScrollingItems(aboutScrollingTrack);
    }
}

function createScrollingItems(trackElement) {
    console.log('Creating scrolling items for track:', trackElement);

    // Image data for scrolling bar with athletic labels - using placeholders for demo
    const scrollingImages = [
        { src: '../assets/images/lifestyle/adventure.jpg', label: 'ADVENTURE' },
        { src: '../assets/images/lifestyle/compete.jpg', label: 'COMPETE' },
        { src: '../assets/images/lifestyle/focus.jpg', label: 'FOCUS' },
        { src: '../assets/images/lifestyle/strength.jpg', label: 'STRENGTH' },
        { src: '../assets/images/lifestyle/endurance.jpg', label: 'ENDURANCE' },
        { src: '../assets/images/lifestyle/power.jpg', label: 'POWER' },
        { src: '../assets/images/lifestyle/speed.jpg', label: 'SPEED' },
        { src: '../assets/images/lifestyle/energy.jpg', label: 'ENERGY' },
        { src: '../assets/images/lifestyle/recovery.jpg', label: 'RECOVERY' },
        { src: '../assets/images/lifestyle/performance.jpg', label: 'PERFORMANCE' }
    ];

    trackElement.innerHTML = '';
    console.log('About to create', scrollingImages.length * 2, 'scrolling items');
    
    // Create two sets for seamless infinite scroll
    for (let set = 0; set < 2; set++) {
        scrollingImages.forEach((imageData, index) => {
            const item = document.createElement('div');
            item.className = 'scrolling-item';
            
            // Add a colored background as fallback
            const colors = ['#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', '#FFEAA7', '#DDA0DD', '#98D8C8', '#F7DC6F', '#BB8FCE', '#85C1E9'];
            item.style.background = colors[index % colors.length];
            
            const img = document.createElement('img');
            img.src = imageData.src;
            img.alt = imageData.label;
            img.loading = 'lazy';
            
            // Add error handling for images
            img.onerror = function() {
                console.log('Image failed to load:', imageData.src);
                this.style.display = 'none';
            };
            
            img.onload = function() {
                console.log('Image loaded successfully:', imageData.src);
            };
            
            const label = document.createElement('div');
            label.className = 'scrolling-label';
            
            const square = document.createElement('div');
            square.className = 'scrolling-label-square';
            
            const text = document.createElement('div');
            text.className = 'scrolling-label-text';
            text.textContent = imageData.label;
            
            label.appendChild(square);
            label.appendChild(text);
            
            item.appendChild(img);
            item.appendChild(label);
            trackElement.appendChild(item);
            
            console.log('Created item:', imageData.label);
        });
    }
    
    console.log('Finished creating scrolling items. Track now has', trackElement.children.length, 'items');
}

// Product card hover effects
document.querySelectorAll('.product-card').forEach(card => {
    card.addEventListener('mouseenter', function() {
        const puckImg = this.querySelector('.product-image img');
        if (puckImg) {
            puckImg.style.transform = 'scale(1.1) rotate(5deg)';
            puckImg.style.transition = 'transform 0.3s ease';
        }
    });
    
    card.addEventListener('mouseleave', function() {
        const puckImg = this.querySelector('.product-image img');
        if (puckImg) {
            puckImg.style.transform = 'scale(1) rotate(0deg)';
        }
    });
});

// Floating pucks parallax effect
window.addEventListener('scroll', function() {
    const scrolled = window.pageYOffset;
    const rate = scrolled * -0.5;
    
    const pucks = document.querySelectorAll('.puck');
    pucks.forEach((puck, index) => {
        const speed = 0.3 + (index * 0.1);
        puck.style.transform = `translateY(${rate * speed}px)`;
    });
});

// Add click handlers for CTA buttons (excluding product-cta which are now links)
document.querySelectorAll('.cta-button, .hero-cta').forEach(button => {
    button.addEventListener('click', function(e) {
        e.preventDefault();
        
        // Create ripple effect
        const ripple = document.createElement('span');
        const rect = this.getBoundingClientRect();
        const size = Math.max(rect.width, rect.height);
        const x = e.clientX - rect.left - size / 2;
        const y = e.clientY - rect.top - size / 2;
        
        ripple.style.width = ripple.style.height = size + 'px';
        ripple.style.left = x + 'px';
        ripple.style.top = y + 'px';
        ripple.style.position = 'absolute';
        ripple.style.borderRadius = '50%';
        ripple.style.background = 'rgba(255, 255, 255, 0.6)';
        ripple.style.transform = 'scale(0)';
        ripple.style.animation = 'ripple 0.6s linear';
        ripple.style.pointerEvents = 'none';
        
        this.appendChild(ripple);
        
        setTimeout(() => {
            ripple.remove();
        }, 600);
        
        // Simulate shop action (replace with actual e-commerce integration)
        console.log('Shop button clicked:', this.textContent);
        
        // Show a temporary message
        showMessage('Coming soon! Follow us for updates.');
    });
});

// Add CSS for ripple animation
const style = document.createElement('style');
style.textContent = `
    @keyframes ripple {
        to {
            transform: scale(4);
            opacity: 0;
        }
    }
    
    button, .cta-button, .hero-cta {
        position: relative;
        overflow: hidden;
    }

    .product-cta {
        position: relative;
        overflow: hidden;
    }
    
    .message {
        position: fixed;
        top: 100px;
        right: 20px;
        background: #455763;
        color: #E8E2DA;
        padding: 1rem 2rem;
        border-radius: 50px;
        box-shadow: 0 10px 30px rgba(69, 87, 99, 0.3);
        z-index: 10000;
        transform: translateX(400px);
        transition: transform 0.3s ease;
    }
    
    .message.show {
        transform: translateX(0);
    }
`;
document.head.appendChild(style);

// Message function
function showMessage(text) {
    const message = document.createElement('div');
    message.className = 'message';
    message.textContent = text;
    document.body.appendChild(message);
    
    setTimeout(() => message.classList.add('show'), 100);
    setTimeout(() => {
        message.classList.remove('show');
        setTimeout(() => message.remove(), 300);
    }, 3000);
}

// Mobile menu toggle (for future implementation)
function toggleMobileMenu() {
    const navLinks = document.querySelector('.nav-links');
    navLinks.classList.toggle('mobile-open');
}

// Lazy loading for images
if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const img = entry.target;
                img.src = img.dataset.src;
                img.classList.remove('lazy');
                imageObserver.unobserve(img);
            }
        });
    });

    document.querySelectorAll('img[data-src]').forEach(img => {
        imageObserver.observe(img);
    });
}

// Performance optimization: Throttle scroll events
function throttle(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

// Apply throttling to scroll events
const throttledScroll = throttle(() => {
    // Navigation scroll effect
    const nav = document.querySelector('.nav');
    if (window.scrollY > 100) {
        nav.style.background = 'rgba(232, 226, 218, 0.98)';
        nav.style.boxShadow = '0 2px 20px rgba(69, 87, 99, 0.15)';
    } else {
        nav.style.background = 'rgba(232, 226, 218, 0.95)';
        nav.style.boxShadow = 'none';
    }
    
    // Parallax effect
    const scrolled = window.pageYOffset;
    const rate = scrolled * -0.5;
    
    const pucks = document.querySelectorAll('.puck');
    pucks.forEach((puck, index) => {
        const speed = 0.3 + (index * 0.1);
        puck.style.transform = `translateY(${rate * speed}px)`;
    });
}, 16); // ~60fps

window.addEventListener('scroll', throttledScroll);